/**
 * @module features/Config
 */

export { Config } from './Config.js';
export { ConfigProvider, withConfig } from './ConfigContext.jsx';
